<template>
    <div v-if="link" @click="handleClick" class="link-carousel-item-root clickable">
        <img :src="img" height="200" style="object-fit: cover;" />
        <div v-if="title" class="overlay" style="font-size: 10px; line-height: 40px;">
            <h6 class="px-3 py-2 mb-0 text-left font-weight-bold white">
                {{ title }}
            </h6>
        </div>
    </div>
    <div v-else class="link-carousel-item-root">
        <img :src="img" height="200" style="object-fit: cover;" />
        <div v-if="title" class="overlay" style="font-size: 10px; line-height: 40px;">
            <h6 class="px-3 py-2 mb-0 text-left font-weight-bold white">
                {{ title }}
            </h6>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Link.CarouselItem',

    props: {
        title: String,
        img: String,
        link: String,
        inSameWindow: Boolean,
    },

    methods: {
        handleClick() {
            this.inSameWindow ? window.open(this.link, '_self') : window.open(this.link, '_blank');
        },
    },
};
</script>

<style lang="css" scoped>

.link-carousel-item-root {
    position: relative;
}

.link-carousel-item-root:hover > img {
    transform: scale(1.04);
}

.overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.55);
    color: white;
    box-shadow: 0px -2px 3px 0px rgba(0,0,0,0.75);
}

.link-carousel-item-root > img {
    width: 100%;
    object-fit: cover;
    transition: transform .2s;
}
</style>
